import { IconNames } from 'ui/theme';
import { MenuItem, MenuItemVariant } from 'ui/components/Menu';

export enum SubstituteItemTableRowActions {
  Delete,
}

export const createActionBarOptions = (
  onAction: (type: SubstituteItemTableRowActions) => void
): MenuItem[] => [
  {
    label: 'Delete Item',
    onOptionClick: () => onAction(SubstituteItemTableRowActions.Delete),
    icon: IconNames.FBODeleteSmall,
    dataQa: 'substitute-item-menu-delete',
    variant: MenuItemVariant.Danger,
  },
];
